<template>
	<!-- 添加合作团长 -->
	<div>
		<el-drawer class="add-cooperation-partner" title="添加合作团长" size="800px" :append-to-body="true" :visible.sync="visible" @closed="reset">
			<div class="drawer-content">
				<div class="drawer-content-title fz-16 mb-24 mt-4">选择团长</div>
				<div class="flex flex-align-center">
					<!-- 搜索框部分 -->
					<div class="flex flex-align-center seach-content">
						<el-input class="search-input" placeholder="请输入团长名称" v-model="institution_name" clearable></el-input>
						<el-button class="searchBtn" @click="getTzList()">搜索</el-button>
					</div>
					<!-- 新增团长提示按钮部分 -->
					<el-button class="ml-16" @click="showPartnerDrawer" type="text">没找到?新增团长</el-button>
				</div>
				<!-- 列表部分 -->
				<div class="mt-24 pos-rela table-list" v-loading="loading">
					<div v-if="tzList.length" class="colonel-table">
						<div class="colonel-table-header">
							<div class="colonel-table-tr">
								<div class="colonel-table-td text-align-center el-check-box" style="width: 40px">
									<el-checkbox label="" v-model="checkAll" :indeterminate="indeterminate"></el-checkbox>
								</div>
								<div class="colonel-table-td fz-14 yx-color-text-regular text-align-left" style="width: 605px">团长名称</div>
							</div>
						</div>
						<div
							class="colonel-table-body"
							v-scroll-lazy-load="{
								loadData,
								distance: 300,
								delay: 1000,
								callback: fn => this.$once('hook:beforeDestroy', () => fn()),
							}"
						>
							<el-checkbox-group v-model="selectedTz">
								<div class="colonel-table-tr" v-for="row in tzList" :key="row.team_institution_id">
									<div class="colonel-table-td text-align-center" style="width: 40px">
										<el-checkbox
											:label="row.team_institution_id"
											:disabled="disabledList.some(item => item.team_institution_id === row.team_institution_id)"
										></el-checkbox>
									</div>
									<div class="colonel-table-td text-align-left" style="width: 605px">{{ row.institution_name }}</div>
								</div>
							</el-checkbox-group>
							<p class="pt-20 pb-20 font-h4-regular yx-color-text-regular flex-center">
								<i class="el-icon-loading fz-16 mr-4" v-if="loadmore.status === 'loading'"></i>
								<span :class="loadmore.status === 'nomore' ? 'nomore' : ''">{{ loadmore.text }}</span>
							</p>
						</div>
					</div>
					<div v-if="!tzList.length && !loading" class="empty-content">
						<img class="empty-search" src="@/assets/public/empty-search@2x.png" alt="" />
						<div class="fz-14 yx-color-text-secondary">搜索无结果</div>
					</div>
				</div>
				<!-- 底部按钮部分 -->
				<div class="bott">
					<span class="pl-24 font-h5-regular yx-color-text-primary">
						已选
						<span class="yx-color-primary">{{ selectedNum }}</span>
						个，最多可选
						<span class="yx-color-primary">{{ limit }}</span>
						个
					</span>
					<div>
						<el-button @click="handleClose">取 消</el-button>
						<el-button class="mr-16" type="primary" @click="submit" :loading="btnloading" :disabled="isAble">保存</el-button>
					</div>
				</div>
			</div>
		</el-drawer>
		<addCommander-dialog ref="addCommanderDialog" @refresh="onRefresh"></addCommander-dialog>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import { getInstitutionBaseList } from '@/api/secondColonelManage';
import addCommanderDialog from '@/components/business/addCommanderDialog/addCommanderDialog.vue';
export default {
	name: 'ChooseCooColonelDrawer',
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_ALL.value,
		},
	},
	data() {
		return {
			visible: false,
			selectedTz: [], // 选中的团长id
			tzList: [], //团长列表
			institution_name: '', //搜索框输入的团长名称
			loading: true,
			btnloading: false,
			limit: 20,
			disabledList: [],
			selectObjArr: [], // 选中的团长对象
			params: {
				page_index: 1,
				page_size: 20,
			},
			loadmore: {
				text: '加载更多',
				status: 'pending',
			},
			checkAll: false,
			indeterminate: false,
		};
	},
	watch: {
		institution_name(val) {
			if (!val) {
				this.getTzList();
			}
		},
		checkAll(val) {
			this.selectedTz = val ? this.tzList.map(item => item.team_institution_id) : [];
		},
		selectedTz(val, pre) {
			// 新增
			if (val.length > pre.length) {
				// 找出新增的ID
				const addedIdArr = val.filter(item => !pre.includes(item));
				// 匹配当前的列表找出新增的对象
				const addedObjArr = this.tzList.filter(item => addedIdArr.includes(item.team_institution_id));
				// 添加到选中的对象列表中
				this.selectObjArr.push(...addedObjArr);
			} else {
				// 找出新增的ID
				const deledIdArr = pre.filter(item => !val.includes(item));
				// 匹配当前的列表找出新增的对象
				deledIdArr.forEach(element => {
					// 匹配找出删除的对象
					const ind = this.selectObjArr.findIndex(item => element === item.team_institution_id);
					// 在选中的对象列表中删除
					this.selectObjArr.splice(ind, 1);
				});
			}
		},
		list: {
			handler(val) {
				this.indeterminate = !!(val.selectedTz.length && val.tzList.length && val.selectedTz.length !== val.tzList.length);
			},
			deep: true,
		},
	},
	components: {
		addCommanderDialog,
	},
	computed: {
		// 已选的个数，外部选中的团长个数+抽屉中已选中的团长个数
		selectedNum() {
			return this.selectedTz.length + this.disabledList.length;
		},
		isAble() {
			return this.selectedNum > this.limit;
		},
		list() {
			return {
				tzList: this.tzList,
				selectedTz: this.selectedTz,
			};
		},
	},
	methods: {
		show(list = []) {
			if (list.length) {
				this.disabledList = list;
			}
			this.getTzList();
			this.visible = true;
		},
		loadData() {
			// 有下一页才会请求接口
			if (this.loadmore.status === 'nomore') {
				return;
			}
			this.params.page_index++;
			this.loadmore = {
				text: '加载中...',
				status: 'loading',
			};
			this.getTzList(true);
		},
		//获取团长列表
		async getTzList(loadMore) {
			if (!loadMore) {
				this.params.page_index = 1;
				this.loading = true;
			}
			if (loadMore && this.loadmore.status === 'nomore') {
				return;
			}
			let { code, data } = await getInstitutionBaseList({ ...this.params, institution_name: this.institution_name, platform_id: this.platformId });

			if (code == 0) {
				if (loadMore) {
					if (data.page.page_has || data.list.length) {
						this.tzList = this.tzList.concat(data.list)
					}
				} else {
					this.tzList = data.list;
				}
				this.loadmore = !data.page.page_has
					? {
							text: '已经到底了',
							status: 'nomore',
					  }
					: {
							text: '加载更多',
							status: 'pending',
					  };
				if (!loadMore) {
					this.loading = false;
				}
			}
		},
		// 保存提交
		submit: debounce(function () {
			this.btnloading = true;
			let params = {};
			const { selectObjArr } = this;
			params = selectObjArr.map(item => {
				// 每次选择团长时添加唯一ID，原因为可重复添加团长
				item.id = item.team_institution_id + '|' + new Date().getTime();
				return item;
			});
			//给该对象加一个id值，且和团长id一样
			this.$emit('getTzList', params);
			this.$message.success('添加成功');
			this.btnloading = false;
			this.reset();
			this.handleClose();
		}, 1000),
		// 关闭
		handleClose() {
			this.visible = false;
			this.params.page_index = 1;
		},
		// 重置
		reset() {
			this.selectedTz = [];
			this.tzInfo = '';
			this.tzList = [];
			this.params.page_index = 1;
			this.disabledList = [];
			this.institution_name = '';
			this.selectObjArr = [];
			this.checkAll = false;
			this.indeterminate = false;
		},
		// 打开新增团长的抽屉
		showPartnerDrawer() {
			this.$refs.addCommanderDialog.show(this.platformId);
		},
		onRefresh(){
			this.list = [];
			this.getTzList();
		}
	},
};
</script>

<style lang="less" scoped>
.drawer-content {
	border-radius: 8px;
	padding: 20px 16px 16px 16px;
	background: @color-gy1;
}
.add-cooperation-partner {
	/deep/.el-input {
		width: 606px !important;
	}
	/deep/ .el-drawer__body {
		padding: 16px !important;
		background: #f7f8f9;
		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @border-color-lighter;
		}
	}
	/deep/ .el-checkbox__label {
		display: none;
	}
}
.searchBtn {
	position: relative;
	left: -1px;
	width: 72px;
	background-color: @color-primary;
	color: @color-gy1;
	font-size: 13px;
	border-radius: 2px;
	height: 34px;
	border-color: transparent !important
}
.tzName {
	border-top: 1px solid #ebedf5;
	border-bottom: 1px solid #ebedf5;
	background-color: #f7f8fa;
	padding-left: 77px;
}
.tzTable {
	height: 50px;
	line-height: 50px;
}
.btline {
	border-bottom: 1px solid #ebedf5;
}
.line {
	position: absolute;
	width: 1px;
	background-color: @border-color-base;
	height: 100%;
	top: 0;
	left: 65px;
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: @color-gy1;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2;
}
/deep/ .el-checkbox__inner {
	border: 1px solid #e2e3e8;
}
.colonel-table {
	display: table;
	width: 100%;
	margin-bottom: 40px;
	&-header {
		color: @color-text-secondary !important;
		font-size: 12px !important;
		font-family: PingFangSC-Regular;
	}
	&-body {
		max-height: 650px;
		overflow-y: auto;
		.nomore {
			&::before {
				content: '- ';
			}
			&::after {
				content: ' -';
			}
		}
	}
	&-tr {
		display: table-row;
	}
	&-td {
		display: table-cell;
		font-size: 12px;
		padding: 10px 0;
		border-bottom: 1px solid @border-color-base;
	}
}
&::-webkit-scrollbar {
	width: 6px;
}

&::-webkit-scrollbar-thumb {
	height: 26px;
	border-radius: 3px;
	background-color: @color-text-placeholder;
}
.drawer-content-title {
	position: relative;
	color: @color-gy9;
	font-weight: 500;
	padding-left: 8px;
}
.drawer-content-title::after {
	content: '';
	width: 3px;
	height: 17px;
	background: @color-b4;
	border-radius: 20px;
	position: absolute;
	left: 0px;
	top: 50%;
	transform: translateY(-50%);
}
.seach-content {
	width: 594px;
	.search-input {
		/deep/ .el-input__inner {
			border-radius: 4px 0px 0px 4px;
		}
	}
}
.colonel-table-header {
	border-radius: 4px 4px 0 0 ;
	background: @color-gy3;
}
.empty-content{
	text-align: center;
	height: calc(100vh - 200px);
	.empty-search{
		margin-top: 76px;
		width: 96px;
		height: 96px;
	}
}
.colonel-table{
	text-align: center;
	height: calc(100vh - 300px);
	overflow: hidden;
}
.colonel-table-body{
	height: calc(100vh - 320px);
}
.table-list{
	height: calc(100vh - 300px);
	overflow: hidden;
}
/deep/ .el-check-box{
	.is-indeterminate .el-checkbox__inner{
		border: 1px solid transparent !important;
	}
}
/deep/ .is-disabled{
	.el-checkbox__inner{
		border: 1px solid #e2e3e8 !important;
	}
}
</style>
